import moment from "moment";
import React from "react";

import { useCalendarContext } from "../../../../context/calendar_context";
import css from "./today.module.scss";

export const Today = (): JSX.Element => {
  const { dayWidth } = useCalendarContext();
  const weekDay = moment().weekday();
  return (
    <div
      className={css.root}
      style={{
        width: dayWidth,
        left: weekDay * dayWidth
      }}
    />
  );
};
